import { render, staticRenderFns } from "./OrganizationProfile.vue?vue&type=template&id=2b2dc1d7&scoped=true"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"
import style0 from "./OrganizationProfile.vue?vue&type=style&index=0&id=2b2dc1d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2dc1d7",
  null
  
)

export default component.exports